import styled, { css } from 'styled-components';
import { space } from 'styled-system';
export var Row = styled.div.withConfig({
  displayName: "DateTimeFormatterstyles__Row",
  componentId: "keen-widget-settings__sc-1dz6wc0-0"
})(["&&&{display:flex;align-items:center;justify-content:space-between;column-gap:10px;", ";", ";}"], space, function (_ref) {
  var isDisabled = _ref.isDisabled;
  return isDisabled && css(["opacity:0.5;pointer-events:none;"]);
});
export var InputWrapper = styled.div.withConfig({
  displayName: "DateTimeFormatterstyles__InputWrapper",
  componentId: "keen-widget-settings__sc-1dz6wc0-1"
})(["&&&{max-width:310px;width:100%;}"]);
export var ControlContainer = styled.div.withConfig({
  displayName: "DateTimeFormatterstyles__ControlContainer",
  componentId: "keen-widget-settings__sc-1dz6wc0-2"
})(["&&&{width:100%;margin-top:10px;max-width:310px;display:flex;column-gap:10px;}"]);
export var DropdownWrapper = styled.div.withConfig({
  displayName: "DateTimeFormatterstyles__DropdownWrapper",
  componentId: "keen-widget-settings__sc-1dz6wc0-3"
})(["&&&{", ";}"], function (_ref2) {
  var isDisabled = _ref2.isDisabled;
  return isDisabled && css(["opacity:0.5;pointer-events:none;"]);
});